<script setup lang="ts">
    import { onMounted, ref, watch } from 'vue';
    import Theme from './Theme.vue';
    import ThemesList from './ThemesList.vue';
    import { setupThemes, getThemeAccess } from './Themes';
    import { setupVisibilityLoader } from '@shared/utils/visibilityLoader';

    const { themesState, createTheme, getThemes, editTheme, showEditorFunc, deleteSelected, updateSelected } = setupThemes();
    const containerEl = ref<Element | null>(null);
    const urlParams = new URLSearchParams(window.location.search);

    const { canEditThemes } = getThemeAccess();

    watch(
        canEditThemes,
        (canEdit) => {
            if (canEdit && urlParams.has('newTheme')) createTheme();
        },
        { immediate: true }
    );

    onMounted(async () => {
        const location = window.location;
        const url = new URL(location.toString());
        const params = url.searchParams;
        const themeId = params.get('themeId');

        if (themeId) {
            editTheme(themeId);
        } else {
            setupVisibilityLoader(containerEl.value, async () => await getThemes());
        }
    });
</script>

<template>
    <div ref="containerEl" v-show="themesState.themeId === null">
        <h2 class="main-title">{{ $Resources.ThemesListHeading }}</h2>

        <ThemesList
            :themes="themesState.themes"
            :isLoading="themesState.isLoading"
            :themeId="themesState.themeId"
            :selected="themesState.selected"
            :createTheme="createTheme"
            :backoffice="false"
            @themeSelected="(id) => editTheme(id)"
            @updateSelected="(newVal) => updateSelected(newVal)"
            @clearSelected="themesState.selected = []"
            @deleteSelected="deleteSelected()"></ThemesList>
    </div>

    <Theme :themeId="themesState.themeId" :backoffice="false" v-show="themesState.themeId !== null" @update:showEditor="showEditorFunc"></Theme>
</template>
